import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'AuditConfiguration/AuditCodes', method: 'GET', token: token })
}
